import React from "react";
import "./Newlivia.scss";
import Comingsoon from "../../media/Livia_Desktop.webp";
import Soon from "../../media/Livia_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6281574115424&text=Halo+Radi%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Livia)%20https://www.grandwisata-marketing.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="livia" className="container-livia">
      <div className="louise">
        <h1>New Launching Grand Wisata</h1>
        <h2> Livia at Ladoria</h2>
      </div>
      <div className="maps-livia">
        <img
          id="location"
          className="img-lokasi-dekstop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
